import styles from './ExternalTicketsPanel.module.scss';
import { useExternalTicketsHeadline } from './hooks/useExternalTicketsHeadline';

export const ExternalTicketsPanelHeadline: React.FC = () => {
  const { headlineText } = useExternalTicketsHeadline();

  if (!headlineText) {
    return null;
  }

  return (
    <div data-testid="conversion-bar-headline" className={styles.headline}>
      <span>{headlineText}</span>
    </div>
  );
};
